import { render, staticRenderFns } from "./SecurityList.vue?vue&type=template&id=8470ff0c&scoped=true"
import script from "./SecurityList.vue?vue&type=script&lang=js"
export * from "./SecurityList.vue?vue&type=script&lang=js"
import style0 from "./SecurityList.vue?vue&type=style&index=0&id=8470ff0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8470ff0c",
  null
  
)

export default component.exports